import type { Any } from "@repo/lib/types";
import { Observable, of } from "rxjs";

/** An any-type observable that never provides a value. */
export const neverObservable = new Observable<Any>();

/** An observable that provides a single null. */
export const nullObservable = of(null);

/** An observable that provides a single undefined. */
export const undefinedObservable = of(undefined);
